module.exports = __webpack_public_path__ + "static/img/img-about-6-1.772b495.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-6-1.png
// module id = +jsv
// module chunks = 0